const env = window.env || process.env;

const configuration = {
  API_URL: env.REACT_APP_API_URL,
  MAX_DISTANCE: Number(env.REACT_APP_MAX_DISTANCE) || 0.1,
};

export default configuration;
